import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  images: {}, // { agentSlug: imageSrc }
};

const AgentImageSlice = createSlice({
  name: "agentImages",
  initialState,
  reducers: {
    setAgentImage: (state, action) => {
      const { slug, image } = action.payload;
      state.images[slug] = image;
    },
    resetAgentImage: (state) => {
      state.images = {};
    },
  },
});

export const { setAgentImage, resetAgentImage } = AgentImageSlice.actions;
export default AgentImageSlice.reducer;
